import React, { useState, useEffect } from 'react'
import { Col, Panel, Row } from 'rsuite'
import InputForm from '../../components/forms/input/InputForm'
import InputSelectForm from '../../components/forms/input/InputSelectForm'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'

export default function ContractFormWitness({
  schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  ...props
}) {
  const [formSchema, setFormSchema] = useState()
  const [witness, setWitness] = useState([])

  useEffect(() => {
    console.log('schema : ', schema)

    setFormSchema(schema)

    if (schema.value || schema.value.length > 0) {
      const list = schema.value
      list.forEach((item, index) => {
        console.log(item)
        register(`witness[${index}]`, item)
        setValue(`witness[${index}]`, item)
      })

      setWitness(schema.value || [])
    }
  }, [schema])

  const renderForm = (item, index) => {
    return (
      <>
        <Row>
          <Col xs={24} sm={24} md={8} lg={8}>
            {errors?.witness && <ErrorMessage error={errors?.witness[index]?.preName} />}
            <InputSelectForm
              searchable={false}
              schema={formSchema.inputForm.preName}
              // name={formSchema.inputForm.preName.name + '_' + index}
              name={`witness[${index}].${formSchema.inputForm.preName.name}`}
              value={item.preNameId}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
              // onChange={onContractTypeChange}
            />
          </Col>
          <Col xs={24} sm={24} md={8} lg={8}>
            {errors?.witness && <ErrorMessage error={errors?.witness[index]?.firstName} />}
            <InputForm
              schema={formSchema.inputForm.firstName}
              // name={formSchema.inputForm.firstName.name + '_' + index}
              name={`witness[${index}].${formSchema.inputForm.firstName.name}`}
              value={item.firstName}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
              // onChange={onContractTypeChange}
            />
          </Col>
          <Col xs={24} sm={24} md={8} lg={8}>
            {errors?.witness && <ErrorMessage error={errors?.witness[index]?.lastName} />}
            <InputForm
              schema={formSchema.inputForm.lastName}
              // name={formSchema.inputForm.lastName.name + '_' + index}
              name={`witness[${index}].${formSchema.inputForm.lastName.name}`}
              value={item.lastName}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
              // onChange={onContractTypeChange}
            />
          </Col>
        </Row>
      </>
    )
  }

  const renderFormNonValidate = (item, index) => {
    return (
      <>
        <Row>
          <Col xs={24} sm={24} md={8} lg={8}>
            {errors?.witness && <ErrorMessage error={errors?.witness[index]?.preName} />}
            <InputSelectForm
              searchable={false}
              schema={formSchema.inputFormNonValidate.preName}
              // name={formSchema.inputFormNonValidate.preName.name + '_' + index}
              name={`witness[${index}].${formSchema.inputFormNonValidate.preName.name}`}
              value={item.preNameId}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
              // onChange={onContractTypeChange}
            />
          </Col>
          <Col xs={24} sm={24} md={8} lg={8}>
            {errors?.witness && <ErrorMessage error={errors?.witness[index]?.firstName} />}
            <InputForm
              schema={formSchema.inputFormNonValidate.firstName}
              // name={formSchema.inputFormNonValidate.firstName.name + '_' + index}
              name={`witness[${index}].${formSchema.inputFormNonValidate.firstName.name}`}
              value={item.firstName}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
              // onChange={onContractTypeChange}
            />
          </Col>
          <Col xs={24} sm={24} md={8} lg={8}>
            {errors?.witness && <ErrorMessage error={errors?.witness[index]?.lastName} />}
            <InputForm
              schema={formSchema.inputFormNonValidate.lastName}
              // name={formSchema.inputFormNonValidate.lastName.name + '_' + index}
              name={`witness[${index}].${formSchema.inputFormNonValidate.lastName.name}`}
              value={item.lastName}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
              // onChange={onContractTypeChange}
            />
          </Col>
        </Row>
      </>
    )
  }

  return (
    <>
      <div>
        <Panel bordered>
          <Row style={{ marginTop: 10 }}>
            <Col xs={24} sm={24} md={24} lg={24}>
              <label style={{ fontWeight: 600 }}>
                {witness.find((i) => i.witnessType == 1)?.header}
              </label>
            </Col>
          </Row>

          {witness.map((item, index) => {
            if (item.witnessType == 1) {
              return renderForm(item, index)
            }
          })}
        </Panel>

        <br />
        <Panel bordered>
          <Row style={{ marginTop: 10 }}>
            <Col xs={24} sm={24} md={24} lg={24}>
              <label style={{ fontWeight: 600 }}>
                {witness.find((i) => i.witnessType == 2)?.header}
              </label>
            </Col>
          </Row>
          {witness.map((item, index) => {
            if (item.witnessType == 2 && index != 2) {
              return renderForm(item, index)
            } 
            // else if (item.witnessType == 2 && index == 2) {
            //   return renderFormNonValidate(item, index)
            // }
          })}
        </Panel>
      </div>
    </>
  )
}
